
import { defineComponent, h } from 'vue';

import { MarkdownContent } from '../types';

import i18n from '@/translate/lang';
import config from 'src/app.config.js';
import { appStoreMapper } from '@/store/appstore';
import { authStoreMapper } from '@/modules/auth/dist/store';
import { openUrl } from '@/misc';

export default defineComponent({
  name: 'RegistrationUserAgreements',
  computed: {
    content(): string {
      return (
        this.settings.eula?.find((i) => i.lang === i18n.locale)?.content ??
        `${i18n.t('modules.auth.registration.eula.part1')} [${i18n.t(
          'modules.auth.registration.eula.part2',
        )}](${config.api.protocol}://${this.clientName}.${
          config.api.host
        }/content/show/eula).`
      );
    },
    contentParts(): MarkdownContent[] {
      const regex = /(\[[^\]]+\]\([^)]+\))/g;
      const parts = this.content.split(regex);

      const result: MarkdownContent[] = [];

      for (const part of parts) {
        if (!part) continue;

        const linkMatch = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (linkMatch) {
          const [, content, href] = linkMatch;
          result.push({ type: 'link', content, href });
        } else {
          result.push({ type: 'text', content: part });
        }
      }

      return result;
    },
    ...appStoreMapper.mapGetters(['clientName']),
    ...authStoreMapper.mapGetters(['settings']),
  },
  render(this: any) {
    return h(
      'f7-block-footer',
      {
        class: [this.$style.footer],
      },
      this.contentParts.map((part: MarkdownContent) => {
        switch (part.type) {
          case 'link':
            return h(
              'f7-link',
              {
                attrs: {
                  href: part.href!,
                },
                props: {
                  external: true,
                },
                on: {
                  click: (e: Event) => {
                    openUrl(part.href!, '_system', e);
                  },
                },
              },
              part.content,
            );

            break;
          case 'text':
          default:
            return part.content;
        }
      }),
    );
  },
});
